/* global gsap, ScrollTrigger */

/**
 * Region Scroll Animation
 */
export default function () {
    if (typeof window === 'undefined') return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector('.region-scroll');
    if (!section) return;

    const panels = gsap.utils.toArray('.region-scroll__panel');
    if (!panels.length) return;

    const img = section.querySelector('.region-scroll__img');
    const imageContainer = section.querySelector('.region-scroll__image');
    const eyebrow = section.querySelector('.region-scroll__eyebrow');
    const heading = section.querySelector('.region-scroll__heading');

    panels.forEach(function (panel) {
        const preloadImg = new Image();
        preloadImg.src = panel.dataset.image;
    });

    gsap.set(section, { height: `${panels.length * 200}vh` });

    let currentPanel = panels[0];

    const FADE_DURATION = 0.2;

    function swapContent(panel) {
        if (panel === currentPanel) return;
        currentPanel = panel;

        gsap.killTweensOf([eyebrow, heading]);

        // Image swaps instantly — it's preloaded, no flash
        img.src = panel.dataset.image;
        img.alt = panel.dataset.alt;

        // Only the text fades
        gsap.to([eyebrow, heading], {
            opacity: 0,
            duration: FADE_DURATION,
            ease: 'power1.inOut',
            onComplete: function () {
                eyebrow.textContent = panel.dataset.eyebrow;
                heading.textContent = panel.dataset.heading;

                gsap.to([eyebrow, heading], {
                    opacity: 1,
                    duration: FADE_DURATION,
                    ease: 'power1.inOut',
                });
            },
        });
    }

    ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: 'bottom bottom',
        pin: '.region-scroll__sticky',
        pinSpacing: false,
    });

    gsap.fromTo(imageContainer,
        { scale: 1 },
        {
            scale: 1.4,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 0.5,
            },
        }
    );

    panels.forEach(function (panel) {
        ScrollTrigger.create({
            trigger: panel,
            start: 'top 50%',
            onEnter: function () { swapContent(panel); },
            onEnterBack: function () { swapContent(panel); },
        });
    });
}
